// Webpack imports
// Global var to use it across components
import '../scss/styles.scss';

// Polyfills
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

// Class and Function Imports
import Scroll from './template.scroll';
import Body from './template.body';
import MobileMenu from './template.mobileMenu';
import Header from './template.header';
import Footer from './template.footer';
// import FooterMenu from './template.footerMenu';
import ScrollTop from './template.scrollTop';
import Teaser from './template.teaser';
import Accordion from './template.accordion';
import Pdp from './template.pdp';
import AddToCart from './template.addToCart';
import ProductStatus from './template.productStatus';
// import Instagram from './template.instagramFeed';
import Tab from './template.tab';
import GoogleTrackingEvents from './../../../Digon.WebPack/src/js/googleTrackingEvents';

document.querySelector('html').classList.remove('no-js');

const inFrame = () => {
    return !(window === window.parent);
};

if (!inFrame()) {
    new Scroll().init();
    new Body().init();
    new MobileMenu().init();
    new Header().init();
    new Footer().init();
    // new FooterMenu().init();
    new ScrollTop().init();
    new Teaser().init();
    new Accordion().init();
    new Pdp().init();
    new AddToCart().init();
    new ProductStatus().init();
    // new Instagram().init();
    new Tab().init();
    new GoogleTrackingEvents().init();
}

// Third party
